import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/user/login/login.component';


import { UiSwitchModule } from 'ngx-ui-switch';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxDropzoneModule } from 'ngx-dropzone';

/*DatePicker*/
import { OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl } from 'ng-pick-datetime';
import { NgModule, LOCALE_ID } from '@angular/core';
import { OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { registerLocaleData } from '@angular/common';
import localeEsCO from '@angular/common/locales/es-CO';

import { ChartsModule } from 'ng2-charts';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { APP_ROUTING } from './app.routes';
import { AuthService } from './services/auth.service';

// Directivas
import { OutsideDirective } from './directives/outside.directive';
import { UppercaseDirective } from './directives/uppercase.directive';
import { } from '@angular/cdk/keycodes';

import { OnlyNumberDirective } from './directives/only-number.directive';
import { PasswordComponent } from './components/user/password/password.component';
import { ReintegrosComponent } from './components/reintegros/reintegros.component';
import { ReportesComponent } from './components/reportes/reportes.component';
import { PqrComponent } from './components/pqr/pqr.component';
import { CargaComponent } from './components/carga/carga.component';
import { BlankComponent } from './components/blank/blank.component';
import { ReplacePipe } from './pipes/replace.pipe';
import { PersonalizacionComponent, SafePipe } from './components/personalizacion/personalizacion.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { FilterPipe } from './pipes/filter.pipe';
import { SumPipe } from './pipes/sum.pipe';
import { ForgotComponent } from './components/user/forgot/forgot.component';
import { BotonContactoComponent } from './components/boton-contacto/boton-contacto.component';
import { TitleComponent } from './components/layout/title/title.component';
import { SearchComponent } from './components/layout/search/search.component';
import { PaginationComponent } from './components/layout/pagination/pagination.component';
import { FilterComponent } from './components/layout/filter/filter.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { DownloadComponent } from './components/layout/download/download.component';
import { ChartStateComponent } from './components/layout/chart-state/chart-state.component';
import { BgUrlPipe } from './pipes/bg-url.pipe';
import { IndividualReportComponent } from './components/reportes/individual-report/individual-report.component';
import { MassiveReportComponent } from './components/reportes/massive-report/massive-report.component';
import { ChartManagementComponent } from './components/reportes/chart-management/chart-management.component';
import { LegalComponent } from './components/user/legal/legal.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PaymentsComponent } from './pages/payments/payments.component';
import { PaymentsDaysHoursChartComponent } from './pages/payments/payments-days-hours-chart/payments-days-hours-chart.component';
import { PaymentsTableComponent } from './pages/payments/payments-table/payments-table.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PaymentsFrequencyChartComponent } from './pages/payments/payments-frequency-chart/payments-frequency-chart.component';
import { SelectChartComponent } from './pages/payments/select-chart/select-chart.component';
import { BankPaymentsDayChartComponent } from './pages/payments/bank-payments-day-chart/bank-payments-day-chart.component';
import { PaymentsCountComponent } from './pages/payments/payments-count/payments-count.component';
import { PaymentsAmountComponent } from './pages/payments/payments-amount/payments-amount.component';
import { MessagePipePipe } from './pipes/message-pipe.pipe';
import { ChartPieComponent } from './components/chart-pie/chart-pie.component';
import { BillsOnlinePaymentComponent } from './pages/payments/bills-online-payment/bills-online-payment.component';
import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';
import { ReportsChartsPageComponent } from './pages/report-charts-page/report-charts-page.component';


registerLocaleData(localeEsCO, 'es-Co');

export class DefaultIntl extends OwlDateTimeIntl {
  rangeFromLabel = 'Fecha inicial';
  rangeToLabel = 'Fecha final';
  hour12AMLabel = 'AM';
  hour12PMLabel = 'PM';
  prevMultiYearLabel = '21 años atrás';
  nextMultiYearLabel = 'Próximos 21 años';
}


// 
import { CiCdConfigService } from 'src/cicd/ci-cd-config.service';
import { APP_INITIALIZER } from '@angular/core';
const ciCdConfigProvider = {
  provide: APP_INITIALIZER,
  useFactory: (configService: CiCdConfigService) => () => configService.loadConfigurations().toPromise(),
  deps: [CiCdConfigService],
  multi: true
}
// 

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PasswordComponent,
    OutsideDirective,
    UppercaseDirective,
    OnlyNumberDirective,
    ReintegrosComponent,
    ReportesComponent,
    PqrComponent,
    CargaComponent,
    BlankComponent,
    ReplacePipe,
    PersonalizacionComponent,
    SafePipe,
    FilterPipe,
    SumPipe,
    ForgotComponent,
    BotonContactoComponent,
    TitleComponent,
    SearchComponent,
    PaginationComponent,
    FilterComponent,
    TooltipDirective,
    DownloadComponent,
    ChartStateComponent,
    BgUrlPipe,
    IndividualReportComponent,
    MassiveReportComponent,
    ChartManagementComponent,
    LegalComponent,
    NotFoundComponent,
    PaymentsComponent,
    PaymentsDaysHoursChartComponent,
    PaymentsTableComponent,
    PaymentsFrequencyChartComponent,
    SelectChartComponent,
    BankPaymentsDayChartComponent,
    PaymentsCountComponent,
    PaymentsAmountComponent,
    MessagePipePipe,
    ChartPieComponent,
    BillsOnlinePaymentComponent,
    CustomCurrencyPipe,
    ReportsChartsPageComponent,
  ],
  imports: [
    BrowserModule,
    NgxPaginationModule,
    NgApexchartsModule,
    ChartsModule,
    ScrollingModule,
    NgxDropzoneModule,
    UiSwitchModule.forRoot({
      size: 'small',
      color: 'rgb(61, 160, 48)',
      switchColor: '#FFFFFF',
      defaultBgColor: 'rgb(151, 151, 151)',
      defaultBoColor: '#dadada',
      checkedLabel: 'Si',
      uncheckedLabel: 'No'
    }),
    Ng2SearchPipeModule,
    CommonModule,
    APP_ROUTING,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BrowserAnimationsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ColorPickerModule,
    NgxSpinnerModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'decreasing',
      maxOpened: 1,
      autoDismiss: true,
      closeButton: true
    })
  ],
  providers: [
    AuthService,
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'es' },
    { provide: OwlDateTimeIntl, useClass: DefaultIntl },
    { provide: LOCALE_ID, useValue: 'es-Co' },
    ciCdConfigProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
